import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  Typography,
  Grid,
} from '@mui/material';
import { BadgeOutlined as BadgeIcon } from '@mui/icons-material';

const EmployeeInfoDialog = ({ open, onClose, user }) => {
  const { t } = useTranslation();

  const fields = [
    { label: t('employeeInfo.firstName'), value: user?.first_name },
    { label: t('employeeInfo.lastName'), value: user?.last_name },
    { label: t('employeeInfo.employeeNumber'), value: user?.employee_number },
    { label: t('employeeInfo.managementLevel'), value: user?.management_level },
    { label: t('employeeInfo.approvalLimit'), value: user?.approval_limit },
    { label: t('employeeInfo.jobCode'), value: user?.job_code },
    { label: t('employeeInfo.jobTitle'), value: user?.job_title },
    { label: t('employeeInfo.department'), value: user?.department },
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <BadgeIcon color='primary' />
          <Typography variant='h6'>{t('employeeInfo.dialogTitle')}</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ pt: 2 }}>
          {fields.map((field, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Typography variant='caption' color='text.secondary'>
                {field.label}
              </Typography>
              <Typography variant='body1'>{field.value || '-'}</Typography>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant='outlined'>
          {t('common.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmployeeInfoDialog;
